export default __webpack_public_path__ + "assets/models/11dd4325801a4fcfa8eaae4fda861c84.glb";